import React from 'react';

export const LayoutContext = React.createContext({
  layoutRef: React.createRef<HTMLDivElement>()
});
